$(function() {

    var adClub = {},
    eventSlider;

    adClub.redirect = function(url){
        window.location = url;
    }

    adClub.init = function(){
        AOS.init();
        adClub.bindEvents();
        adClub.eventSlider();
        adClub.calendarExternalLink();
    }

    adClub.bindEvents = function(){
        // Members list link to single
        $('.member.card').on('click', function(e){
            if(e.target.tagName != "A"){
                var url = $(this).attr('data-href');
                adClub.redirect(url);
            }
        })

        $('#mobile-menu .menu-items > ul > li ul').slideUp();

        var i = 0.1;
        $('#mobile-menu .menu-items > ul > li').each(function(e){
            i = i + 0.075;
            var trans_delay = i + 's';
            //console.log(trans_delay)
            $(this).css('transition-delay', trans_delay);
        });

        $('#mobile-menu .menu-items > ul > li').on('click', function(e){
            //console.log(e.target);
            if( !$(this).hasClass('open') ){
                $('#mobile-menu .menu-items > ul > li ul').slideUp();
                $(this).parent().find('li').removeClass('open');
                $(this).addClass('open');
                $(this).find('ul').slideDown();
            } else {
                $(this).parent().find('ul').slideUp();
                $(this).removeClass('open');
            }
        });

        $('#mobile-menu .menu-toggle').on('click', function(e){
            $('html').toggleClass('menu-open');
            $(this).toggleClass('is-active');
            $(this).parent().toggleClass('open');
        })
    }

    adClub.eventSlider = function(){
        eventSlider = new Swiper ('.swiper-container-1', {
            //direction: 'vertical',
            loop: true,
            setWrapperSize: true,
            autoHeight: true,
            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
        })
		if (window.innerWidth < 998) {
			eventSlider2 = new Swiper ('.swiper-container-2', {
				loop: true,
				setWrapperSize: true,
				autoHeight: true,
				slidesPerView: 1,
				spaceBetween: 25,
				// Navigation arrows
				navigation: {
				  nextEl: '.swiper-button-next',
				  prevEl: '.swiper-button-prev',
				}
			})
		} else {
			eventSlider2 = new Swiper ('.swiper-container-2', {
				loop: true,
				setWrapperSize: true,
				autoHeight: true,
				slidesPerView: 5,
				spaceBetween: 25,
				// Navigation arrows
				navigation: {
				  nextEl: '.swiper-button-next',
				  prevEl: '.swiper-button-prev',
				}
			})
		}
    }

	adClub.calendarExternalLink = function() {
		if ($('.fc-day-grid-event .external-link')) {
			$('.fc-day-grid-event .external-link').each(function(){
				if ($(this).html() !== "") {
					$(this).closest('.fc-day-grid-event').attr('href',$(this).html())
					$(this).closest('.fc-day-grid-event').attr('target','_blank')
				}
			})
		}
		$('.fc-button').on('click',function() {
			console.log($('.fc-day-grid-event .external-link'))
			$('.fc-day-grid-event .external-link').each(function(){
				if ($(this).html() !== "") {
					$(this).closest('.fc-day-grid-event').attr('href',$(this).html())
					$(this).closest('.fc-day-grid-event').attr('target','_blank')
				}
			})
		})
	}

    /*
    adClub.getEvents = function(){
        axios({
            method: 'GET',
            url: '/wp-json/wp/v2/event?' + new URLSearchParams({
                per_page: 100
            })
        })
        .then(function (response) {

            console.log(response);

        }).catch(function (error) {

            console.log(error);

        });
    }
    */


    adClub.init();

});
